import { ValidateApplicationPolicyResponse } from 'src/configs/APISchemas/ValidateUserPolicyGraphQL';
import { COMPLIANCE_APPLICATION_STATUS } from 'src/constants/compliance';
import { ROUTES } from 'src/constants/routes';

export const handleApplicationStatus = (
  responseData: ValidateApplicationPolicyResponse['validateApplicationPolicy'],
) => {
  const applicationStatus = responseData?.application?.status;
  let routeToNavigateTo = null;

  switch (applicationStatus) {
    case COMPLIANCE_APPLICATION_STATUS.COMPLIANT: {
      routeToNavigateTo = ROUTES.COMPLIANCE_ALREADY_VERIFIED_PATH;
      break;
    }
    case COMPLIANCE_APPLICATION_STATUS.COMPLIANCE_STARTED:
    case COMPLIANCE_APPLICATION_STATUS.NEEDS_REVIEW: {
      routeToNavigateTo = ROUTES.COMPLIANCE_UPLOAD_SUCCESS_PATH;
      break;
    }
  }

  return routeToNavigateTo;
};
